/* East Moon — Theme JS */
document.addEventListener('DOMContentLoaded', function () {

  /* ── FAQ TOGGLE ── */
  document.querySelectorAll('.faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
        var b = i.querySelector('.faq-btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── STICKY CART ── */
  var sticky = document.getElementById('stickyCart');
  var pricingEl = document.getElementById('pricing');
  if (sticky && pricingEl) {
    window.addEventListener('scroll', function () {
      var r = pricingEl.getBoundingClientRect();
      sticky.classList.toggle('visible', r.top < -100);
    });
  }

  /* ── SCROLL ANIMATION ── */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll(
      '.how-step, .ingredient, .benefit-card, .tcard, .stat-card, .timeline-item, .pcard'
    ).forEach(function (el) {
      el.classList.add('anim-on-scroll');
      observer.observe(el);
    });
  }

  /* ── MOBILE NAV TOGGLE ── */
  var hamburger = document.querySelector('.nav-hamburger');
  var navLinks = document.querySelector('.nav-links');
  if (hamburger && navLinks) {
    hamburger.addEventListener('click', function () {
      var isOpen = navLinks.style.display === 'flex';
      navLinks.style.cssText = isOpen
        ? ''
        : 'display:flex;flex-direction:column;position:absolute;top:68px;left:0;right:0;background:var(--navy);padding:20px 28px;border-bottom:1px solid var(--border);gap:16px;z-index:300;';
    });
  }

});
